import { Type } from "class-transformer";

export class InterventionBulkUpdateFailureOutDTO {
  interventionId!: string;
  ref?: number;
  pointOfSaleName?: string;
  /** `ErrorCode` de l'API, traduit via `translateError()`. */
  code!: string;
}

export class InterventionBulkUpdateOutDTO {
  updated!: number;

  @Type(() => InterventionBulkUpdateFailureOutDTO)
  failed!: InterventionBulkUpdateFailureOutDTO[];
}
